<template>
  <div class="d-flex" id="wrapper">
    <div class="border-right-0" id="sidebar-wrapper">
      <UserNavigationSidebar :toggler.sync="isToggled" />

      <!-- Page Content -->
    </div>

    <div id="page-content-wrapper">
      <TopNavbar :profile="getUserProfile" @toggled="toggleSidebarNav" />

      <div class="card">
        <section id="search-job" class="mt-5">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-md-12">
                <SearchJobList />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <!-- End page-content-wrapper -->
  </div>
</template>

<script>
import { toggleSidebarNav } from '../../mixins/toggleSidebarNav';

import TopNavbar from '@/components/Navigations/TopNavbar';
import UserNavigationSidebar from '@/components/Navigations/UserNavigationSidebar';
import SearchJobList from '@/components/SearchJob/SearchJobList';
import { mapActions, mapGetters } from 'vuex';

export default {
  mixins: [toggleSidebarNav],
  components: {
    UserNavigationSidebar,
    TopNavbar,
    SearchJobList,
  },
  data: () => ({ isToggled: false }),
  methods: {
    ...mapActions(['retrieveCandidateUserProfile']),
  },
  computed: { ...mapGetters(['getUserProfile']) },
  mounted() {
    this.retrieveCandidateUserProfile();
  },
};
</script>
<style lang="scss" scoped>
.card {
  min-height: calc(100vh - 135px);
}
</style>